export default {
  data: () => ({
    popperOptions: {
      modifiers: {
        preventOverflow: { enabled: false },
        hide: {
          enabled: false,
        },
      },
    },
  }),
};
